import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const EmailTabs = ({ tab, handleChangeTab }: any) => {
  return (
    <Grid
      container
      sx={{ borderBottom: 1, borderColor: "divider", paddingRight: "30px" }}
      alignItems="center"
    >
      <Tabs value={tab} onChange={handleChangeTab} aria-label="product tab">
        <Tab label="Details" {...a11yProps(0)} />
        {/* <Tab label="Report" {...a11yProps(1)} /> */}
        <Tab label="History" {...a11yProps(1)} />
      </Tabs>
      <Box
        sx={{
          marginLeft: "auto",
        }}
      >
        <Button variant="text">CHECK STATUS</Button>
      </Box>
    </Grid>
  );
};

export default EmailTabs;
